import { makeStyles } from '@material-ui/core/styles'
import { GRAY_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  updateList: props => ({
    position: 'fixed',
    bottom: 0,
    width: '100%',
    height: '20vh',
    zIndex: 999,
    margin: 0,
    padding: 12,
    borderTop: `1px solid ${GRAY_COLORS[200]}`,
    backgroundColor: GRAY_COLORS[50],
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      height: props.page === 'tasks' ? '35vh' : '30vh'
    }
  }),
  wrapper: {
    maxWidth: 1450,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  counts: {
    marginBottom: 24
  },
  updateListBtn: {
    display: 'flex',
    gap: 6,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  }
}))
